import { CSSProperties } from 'react';
import {
  CssFontFamily,
  CssFontStretch,
  CssFontStyle,
  CssFontWeight,
  JavascriptFontStretch,
  JavascriptFontStyle,
  JavascriptFontWeight,
} from './FormattingConverterConstants';
import { IFormattingConverterObject } from './IFormattingConverterObject';
import { isNullOrUndefined } from './utils/TypeUtil';

export class CssPropertiesFormattingConverterObject implements IFormattingConverterObject {
  private readonly cssProperties: CSSProperties;

  public constructor(cssProperties: CSSProperties) {
    this.cssProperties = cssProperties;
  }

  getFontFamily(): string {
    return this.cssProperties.fontFamily ? this.cssProperties.fontFamily.toString() : '';
  }

  setCSS(newCss: Record<string, never>): void {
    for (const [key, value] of Object.entries(newCss)) {
      switch (key) {
        case CssFontStyle:
          this.cssProperties.fontStyle = value;
          break;
        case CssFontWeight:
          this.cssProperties.fontWeight = value;
          break;
        case CssFontStretch:
          this.cssProperties.fontStretch = value;
          break;
        case CssFontFamily:
          this.cssProperties.fontFamily = value;
          break;
      }
    }
  }

  hasStyleProperty(javascriptPropertyName: string): boolean {
    switch (javascriptPropertyName) {
      case JavascriptFontStyle:
        return !isNullOrUndefined(this.cssProperties.fontStyle);
      case JavascriptFontWeight:
        return !isNullOrUndefined(this.cssProperties.fontWeight);
      case JavascriptFontStretch:
        return !isNullOrUndefined(this.cssProperties.fontStretch);
      default:
        return false;
    }
  }
}
